import { deepcopy } from './utility.js';
import { isLayerWithQuery } from './layer.js';
import * as d3 from 'd3';

export function queryAxis(role, spec, original, specifier, action, option) {
  let axisElements = [];
  if (specifier.field !== undefined || specifier.datatype !== undefined) {
    if (["view.axis", "axis"].includes(role) || ["view.hAxis", "hAxis"].includes(role)) {
      let _theField = spec.layout.column[spec.layout.column.length - 1]?.field || spec.layout.column[spec.layout.column.length - 1],
        _theType = spec.layout.column[spec.layout.column.length - 1]?.type || spec.datatype[_theField].type;
      if ((specifier.field === undefined || _theField === specifier.field) && (specifier.datatype === undefined || _theType === specifier.datatype)) {
        axisElements.push("hAxis");
      }
      _theField = spec.layout.column[0]?.field || spec.layout.column[0];
      _theType = spec.layout.column[0]?.type || spec.datatype[_theField].type;
      if (spec.layout.column.length == 2 && (specifier.field === undefined || _theField === specifier.field) && (specifier.datatype === undefined || _theType === specifier.datatype)) {
        axisElements.push("rowHeader")
      }
    }
    if (["view.axis", "axis"].includes(role) || ["view.vAxis", "vAxis"].includes(role)) {
      let _theField = spec.layout.row[spec.layout.row.length - 1]?.field || spec.layout.row[spec.layout.row.length - 1],
        _theType = spec.layout.row[spec.layout.row.length - 1]?.type || spec.datatype[_theField]?.type;
      if ((specifier.field === undefined || _theField === specifier.field) && (specifier.datatype === undefined || _theType === specifier.datatype)) {
        axisElements.push("vAxis");
      }
      _theField = spec.layout.row[0]?.field || spec.layout.row[0];
      _theType = spec.layout.row[0]?.type || spec.datatype[_theField]?.type;
      if (spec.layout.row.length == 2 && (specifier.field === undefined || _theField === specifier.field) && (specifier.datatype === undefined || _theType === specifier.datatype)) {
        axisElements.push("columnHeader");
      }
    }
  } else if (["view.hAxis", "hAxis"].includes(role) && specifier.index !== undefined) {
    // selection by index (horizontal)
    // array of indices is not yet available
    if ((specifier.index == 1 || specifier.index === "first") && spec.layout.row.length == 2) axisElements.push("columnHeader");
    else if ((specifier.index == 2 || specifier.index === "last") && spec.layout.row.length == 2) axisElements.push("hAxis");
    else if ((specifier.index === "first" || specifier.index === "last" || specifier.index == 1) && spec.layout.row.length == 1) axisElements.push("hAxis");
  } else if (["view.vAxis", "vAxis"].includes(role) && specifier.index !== undefined) {
    // selection by index (vertical)
    // array of indices is not yet available
    if ((specifier.index == 1 || specifier.index === "first") && spec.layout.row.length == 2) axisElements.push("rowHeader");
    else if ((specifier.index == 2 || specifier.index === "last") && spec.layout.row.length == 2) axisElements.push("vAxis");
    else if ((specifier.index === "first" || specifier.index === "last" || specifier.index == 1) && spec.layout.row.length == 1) axisElements.push("vAxis");
  } else {
    if (["view.axis", "axis"].includes(role)) axisElements = ["hAxis", "columnHeader", "vAxis", "rowHeader"];
    else if (["view.hAxis", "hAxis"].includes(role)) axisElements = ["hAxis", "columnHeader"];
    else if (["view.vAxis", "vAxis"].includes(role)) axisElements = ["vAxis", "rowHeader"];
  }
  return axisElements;
}


export async function AxisTransformation(role, spec, original, specifier, action, option) {
  let axisElements = queryAxis(role, spec, original, specifier, action, option);
  let fieldname;
  axisElements.forEach(axisItem => {
    if (action === "add") {
      // get fieldname
      if (specifier.field) fieldname = specifier.field;
      else if (axisItem == "hAxis") fieldname = spec.layout.column[spec.layout.column.length - 1];
      else if (axisItem == "vAxis") fieldname = spec.layout.row[spec.layout.row.length - 1];
      else if (axisItem == "columnHeader") fieldname = spec.layout.row[0];
      else if (axisItem == "rowHeader") fieldname = spec.layout.column[0];
      if (fieldname.constructor.name === "Object") fieldname = fieldname.field || fieldname.aggregate;
      // add values
      if (option.values) {

        if (axisItem == "hAxis" || axisItem == "vAxis") spec.layer.forEach(layerItem => {
          layerItem.text?.forEach(textItem => {
            if (textItem.field === fieldname && textItem.type === "on-axis") {
              textItem.values.push(...option.values);
              textItem.values = textItem.values.sort(d3.ascending);
            }
          })
        });
        else if (axisItem == "columnHeader") {
          spec.layout.column[0]?.sort?.order?.push(...option.values);
        }
        else if (axisItem == "rowHeader") {
          spec.layout.row[0]?.sort?.order?.push(...option.values);
        }

      }

      spec.layer.forEach((layerItem, li) => {
        let flag = true;
        if (specifier.layer) {
          flag = isLayerWithQuery(layerItem, li, specifier.mark, specifier.layer.index, specifier.layer.id);
        }
        if (!flag) return;
        if (option.role === "label") {
          let found = false;
          spec.layer.forEach(layerItem => {
            layerItem.text?.forEach(textItem => {
              if (textItem.field === fieldname && textItem.type === "on-axis") {
                found = true;
                if (option.values) textItem.values.push(...option.values);
              }
            });
          });
          if (!found) {
            let newTextItem = { "type": "on-axis", "field": fieldname };

            if (option.values) newTextItem.values = deepcopy(option.values);
            if (option.items) newTextItem.items = deepcopy(option.items);
            else newTextItem.items = [{}];
            Object.keys(option).forEach(propertyKey => {
              let _propertyKey = { "textAlign": "align" }[propertyKey] || propertyKey;
              if (!["role", "values", "items", "dx", "dy", "angle", "orient", "anchor", "x", "y"].includes(_propertyKey)) {
                newTextItem.items.forEach(textElem => {
                  if (option[propertyKey] === null) delete textElem[_propertyKey];
                  else textElem[_propertyKey] = option[propertyKey];
                })
              } else if (["dx", "dy", "angle", "orient", "anchor", "x", "y"].includes(_propertyKey)) {
                if (option[propertyKey] === null) delete newTextItem[_propertyKey];
                else newTextItem[_propertyKey] = option[propertyKey];
              }
            })
            if (!layerItem.text) layerItem.text = [];
            layerItem.text.push(newTextItem);
          }
        } else if (option.role === "tick") {
          if (axisItem === "hAxis" || axisItem === "vAxis") {
            // label tick setting
            spec.layer?.forEach((layer) => {
              layer.text?.forEach((textItem) => {
                if (textItem.field === fieldname && textItem.type === "on-axis") {
                  if (textItem.tick === undefined) textItem.tick = {};
                  Object.keys(option).forEach(propertyKey => {
                    let _propertyKey = { "strokeDash": "tickDash", "stroke": "tickColor", "strokeWidth": "tickWidth", "strokeOpacity": "tickOpacity" }[propertyKey] || propertyKey;
                    if (!["role", "values", "items", "dx", "dy", "angle", "orient", "anchor", "x", "y", "textAlign"].includes(propertyKey)) {
                      if (option[_propertyKey] === null) delete textItem.tick[propertyKey];
                      else textItem.tick[_propertyKey] = option[propertyKey];
                    }
                  });
                }
              });
            });
          }
        } else if (option.role === "grid") {
          if (axisItem === "hAxis" || axisItem === "vAxis") {
            if (spec.layout[axisItem === "hAxis" ? "haxis" : "vaxis"] === undefined) spec.layout[axisItem === "hAxis" ? "haxis" : "vaxis"] = {};
            let axisDesign = spec.layout[axisItem === "hAxis" ? "haxis" : "vaxis"];
            axisDesign.grid = true;
            Object.keys(option).forEach(propertyKey => {
              let _propertyKey = { "strokeDash": "gridDash", "stroke": "gridColor", "strokeWidth": "gridWidth" }[propertyKey] || propertyKey;
              if (!["role", "values", "items", "dx", "dy", "angle", "orient", "anchor", "x", "y", "textAlign"].includes(propertyKey)) {
                if (option[_propertyKey] === null) delete axisDesign[propertyKey];
                else axisDesign[_propertyKey] = option[propertyKey];
              }
            })
          }
        } else if (option.role === "title") {
          let found = false;
          spec.layer.forEach(layerItem => {
            layerItem.text?.forEach(textItem => {
              if (textItem.field === fieldname && textItem.type === "on-axis") {
                found = true;
                if (textItem.title === undefined) textItem.title = {};
                Object.keys(option).forEach(subPropertyKey => {
                  let _subPropKey = { textAlign: "align", rotate: "angle", text: "value" }[subPropertyKey] || subPropertyKey;
                  if (!["type", "field", "items", "role"].includes(subPropertyKey)) {
                    if (option[propertyKey][subPropertyKey] !== null) {
                      textItem.title[_subPropKey] = option[propertyKey][subPropertyKey];
                    } else delete textItem.title[_subPropKey];
                  }
                });
              }
            });
          });
        } else {
          layerItem.text?.forEach(textItem => {
            if (textItem.field === fieldname && textItem.type === "on-axis") {
              if (option.values !== undefined && Object.keys(option).length == 1) {
                // when every element is conditioned & it's a simple addition => add to the longest one
                if (textItem.items.every(d => d.condition !== undefined)) {
                  // add to condition
                  let maxCondition = Math.max(...textItem.items.map(d => d.condition.length));
                  textItem.items.forEach(textElem => {
                    if (textElem.condition.length == maxCondition) {
                      textElem.condition.push(...option.values)
                      textElem.condition = textElem.condition.sort(d3.ascending);
                    }
                  });
                }
              } else if (option.values !== undefined && option.label !== undefined && Object.keys(option).length == 2) {
                if (option.label.items?.text !== undefined) {
                  let len = (option.label.items.text.constructor.name !== "Array" ? 1 : option.label.items.text.length);
                  let valueToAdd;
                  if (textItem.values !== undefined) {
                    textItem.values?.forEach(valueItem => {
                      // find matched number
                      let count = d3.sum(textItem.items.map(d => (d.condition?.includes(valueItem) ? 1 : 0)));
                      if (count == len && !valueToAdd) { valueToAdd = valueItem; }
                    })
                  }
                  let additional_items = [];
                  if (valueToAdd) {
                    let add_count = 0;
                    textItem.items.forEach((textElem, ti) => {
                      if (textElem.condition.includes(valueToAdd)) {
                        let add_item = deepcopy(textElem);
                        add_item.condition = option.values;
                        if (!add_item.format) {
                          add_item.value = option.label.items.text[add_count];
                        }
                        add_count += 1;
                        additional_items.push({
                          "at": additional_items.length + ti,
                          "item": add_item
                        });
                      }
                    });
                  }
                  if (additional_items.length > 0) additional_items.forEach((add_item_obj, ai) => {
                    textItem.items.splice(add_item_obj.at, 0, add_item_obj.item);
                  });
                }
              } else if (option.values !== undefined && Object.keys(option).length > 1) {
                // todo: addition with sytling
                // query longest-condition one; copy with styling
                if (textItem.items.every(d => d.condition !== undefined)) {
                  let additional_items = [];
                  // add to condition
                  let maxCondition = Math.max(...textItem.items.map(d => d.condition.length));
                  textItems.items.forEach((textElem, ti) => {
                    if (textElem.condition.length == maxCondition) {
                      let add_item = deepcopy(textElem);
                      add_item.condition = option.values;
                      Object.keys(option).forEach(propertyKey => {
                        if (!["values", "label"].includes(propertyKey)) {
                          let _propertyKey;
                          if (propertyKey === "textAlign") _propertyKey = "align";
                          else _propertyKey = propertyKey;
                          if (option[propertyKey].constructor.name === "Array") {
                            add_item[_propertyKey] = option[propertyKey][ti];
                          } else if (option[propertyKey] !== null) {
                            add_item[_propertyKey] = option[propertyKey];
                          } else delete add_item[_propertyKey];
                        }
                      });
                      additional_items.push({
                        "at": additional_items.length + ti,
                        "item": add_item
                      });
                    }
                  });
                  if (additional_items.length > 0) additional_items.forEach((add_item_obj, ai) => {
                    textItem.items.splice(add_item_obj.at, 0, add_item_obj.item);
                  });
                }
              } else if (option.values !== undefined && option.label !== undefined && Object.keys(option).length > 2) {
                //todo: complex addition

              }
            }
          });
        }
      });

    } else if (action === "remove") {
      if (option?.values !== undefined || specifier.values !== undefined) {
        // get fieldname
        let values;
        if (specifier.values !== undefined && option?.values === undefined) values = specifier.values;
        else values = option.values;
        if (specifier.field) fieldname = specifier.field;
        else if (axisItem == "hAxis") fieldname = spec.layout.column[spec.layout.column.length - 1];
        else if (axisItem == "vAxis") fieldname = spec.layout.row[spec.layout.row.length - 1];
        else if (axisItem == "columnHeader") fieldname = spec.layout.row[0];
        else if (axisItem == "rowHeader") fieldname = spec.layout.column[0];
        if (fieldname.constructor.name === "Object") fieldname = fieldname.field;
        // remove values
        if (axisItem == "hAxis" || axisItem == "vAxis") spec.layer.forEach(layerItem => {
          layerItem.text?.forEach(textItem => {
            if (textItem.field === fieldname && textItem.type === "on-axis") {
              if (values !== undefined) {
                textItem.values = textItem.values.filter(d => !values?.includes(d));
              }
            }
          })
        });
        if (axisItem == "columnHeader" && spec.layout.column[0]?.sort?.order !== undefined)
          spec.layout.column[0].sort.order = spec.layout.column[0].sort.order.filter(d => !values.includes(d));
        else if (axisItem == "rowHeader" && spec.layout.row[0]?.sort?.order !== undefined)
          spec.layout.row[0].sort.order = spec.layout.row[0].sort.order.filter(d => !values.includes(d));;
      } else if (option?.["values.index"] !== undefined || specifier["values.index"] !== undefined) {
        // get fieldname
        let values;
        if (specifier["values.index"] !== undefined && option?.["values.index"] === undefined) values = specifier["values.index"];
        else values = option["values.index"];
        if (specifier.field) fieldname = specifier.field;
        else if (axisItem == "hAxis") fieldname = spec.layout.column[spec.layout.column.length - 1];
        else if (axisItem == "vAxis") fieldname = spec.layout.row[spec.layout.row.length - 1];
        else if (axisItem == "columnHeader") fieldname = spec.layout.row[0];
        else if (axisItem == "rowHeader") fieldname = spec.layout.column[0];
        if (fieldname.constructor.name === "Object") fieldname = fieldname.field;
        // remove values
        if (axisItem == "hAxis" || axisItem == "vAxis") spec.layer.forEach(layerItem => {
          layerItem.text?.forEach(textItem => {
            if (textItem.field === fieldname && textItem.type === "on-axis") {
              if (values === "even") {
                values = textItem.values.filter((d, i) => { return i % 2 == 1 });
              } else if (values === "odd") {
                values = textItem.values.filter((d, i) => { return i % 2 == 0 });
              }
              if (values !== undefined) {
                textItem.values = textItem.values.filter(d => !values?.includes(d));
              }
            }
          })
        });
        if (axisItem == "columnHeader" && spec.layout.column[0]?.sort?.order !== undefined)
          spec.layout.column[0].sort.order = spec.layout.column[0].sort.order.filter(d => !values.includes(d));
        else if (axisItem == "rowHeader" && spec.layout.row[0]?.sort?.order !== undefined)
          spec.layout.row[0].sort.order = spec.layout.row[0].sort.order.filter(d => !values.includes(d));;
      } else if (option?.["values.filter"] !== undefined || specifier["values.filter"] !== undefined) {
        if (specifier.field) fieldname = specifier.field;
        else if (axisItem == "hAxis") fieldname = spec.layout.column[spec.layout.column.length - 1];
        else if (axisItem == "vAxis") fieldname = spec.layout.row[spec.layout.row.length - 1];
        else if (axisItem == "columnHeader") fieldname = spec.layout.row[0];
        else if (axisItem == "rowHeader") fieldname = spec.layout.column[0];
        if (fieldname.constructor.name === "Object") fieldname = fieldname.field;

        // remove values
        if (axisItem == "hAxis" || axisItem == "vAxis") spec.layer.forEach(layerItem => {
          layerItem.text?.forEach(textItem => {
            if (textItem.field === fieldname && textItem.type === "on-axis") {
              textItem.values = textItem.values.filter(d => {
                return !eval(option["values.filter"].replace(/datum\.value/g, d))
              });
            }
          })
        });
      }

    } else if (action === "replace") {
      if (option.to !== undefined) {
        if (["legend", "layer.legend", "mark.label"].includes(option.to.role)) {
          // get fieldname
          if (specifier.field) fieldname = specifier.field;
          else if (axisItem == "hAxis") fieldname = spec.layout.column[spec.layout.column.length - 1];
          else if (axisItem == "vAxis") fieldname = spec.layout.row[spec.layout.row.length - 1];
          else if (axisItem == "columnHeader") fieldname = spec.layout.row[0];
          else if (axisItem == "rowHeader") fieldname = spec.layout.column[0];
          if (fieldname.constructor.name === "Object") fieldname = fieldname.field;

          let order;
          if (axisItem == "hAxis" && spec.layout.column[spec.layout.column.length - 1].sort?.order !== undefined) order = spec.layout.column[spec.layout.column.length - 1].sort?.order;
          else if (axisItem == "vAxis" && spec.layout.row[spec.layout.row.length - 1].sort?.order !== undefined) order = spec.layout.row[spec.layout.row.length - 1].sort?.order;
          else if (axisItem == "columnHeader" && spec.layout.column[0].sort?.order !== undefined) order = spec.layout.row[0].sort?.order;
          else if (axisItem == "rowHeader" && spec.layout.column[0].sort?.order !== undefined) order = spec.layout.column[0].sort?.order;
          // make change
          spec.layer.forEach(layerItem => {
            // QUERY
            if (option.mark === undefined || (option.mark !== undefined && option.mark === layerItem.mark.type)) {
              layerItem.text?.forEach(textItem => {
                // retrieve axis element
                if (textItem.type === "on-axis" && textItem.field === fieldname) {
                  if (["legend", "layer.legend"].includes(option.to.role)) {
                    textItem.type = "legend";
                    if (option.to.channel) {
                      textItem.channel = option.to.channel;
                    }
                  }
                  else if (["mark.label"].includes(option.to.role)) textItem.type = "on-mark";
                  // property changes
                  if (order !== undefined) {
                    Object.keys(layerItem.mark).forEach(channelKey => {
                      if (!["type"].includes(channelKey) && (channelKey === option.to.channel || option.to.channel === undefined || (
                        option.to.channel === "color" && (channelKey === "fill" || channelKey === "stroke")
                        && fieldname === layerItem.mark[channelKey].field))) {
                        if (layerItem.mark[channelKey].scale?.domain?.constructor?.name === "Array" && layerItem.mark[channelKey].scale?.range?.constructor?.name === "Array") {
                          let reorderMap = layerItem.mark[channelKey].scale.domain.map(dm => order.indexOf(dm));
                          layerItem.mark[channelKey].scale.range = reorderMap.map((di) => layerItem.mark[channelKey].scale.range[di]);
                          layerItem.mark[channelKey].scale.domain = deepcopy(order);
                        }
                      }
                    })
                  }
                  const non_property = ["row", "column", "facet", "axis", "hAxis", "vAxis"];
                  Object.keys(option.to).forEach(propertyKey => {
                    if (!["role", "field", "mark", "operation", "channel"].includes(propertyKey)) {
                      if (propertyKey == "position" && option.to.role === "legend") {
                        if (option.to.position !== null) {
                          if (option.to.position.constructor.name === "String") {
                            textItem["orient"] = option.to.position;
                          } else if (option.to.position.constructor.name === "Array") {
                            textItem["orient"] = "none";
                            textItem["legendX"] = option.to.position[0];
                            textItem["legendY"] = option.to.position[1];
                          }
                        } else {
                          delete textItem["orient"];
                          delete textItem["legendX"];
                          delete textItem["legendY"];
                        }
                      } else if (propertyKey == "x" && option.to.role === "legend") {
                        if (option.to.x !== null) {
                          textItem["orient"] = "none";
                          textItem["legendX"] = option.to.x;
                        } else {
                          delete textItem["orient"];
                          delete textItem["legendX"];
                        }
                      } else if (propertyKey == "y" && option.to.role === "legend") {
                        if (option.to.y !== null) {
                          textItem["orient"] = "none";
                          textItem["legendY"] = option.to.y;
                        } else {
                          delete textItem["orient"];
                          delete textItem["legendY"];
                        }
                      } else if (propertyKey == "margin" && option.to.role === "legend") {
                        if (option.to.margin !== null) {
                          textItem["offset"] = option.to.margin;
                        } else {
                          delete textItem["offset"];
                        }
                      } else if (propertyKey == "width" && option.to.role === "legend") {
                        textItem["width"] = option.to.width;
                        textItem.items?.forEach(d => d.width = option.to.width);
                      } else {
                        if (option.to[propertyKey] !== null) textItem[propertyKey] = option.to[propertyKey];
                        else textItem[propertyKey];
                      }
                    }
                  });
                }
              })
            }
          })
        }
      }
    } else if (action === "modify" || action === "reposition") {
      if (option !== undefined) {
        // get fieldname
        if (specifier.field) fieldname = specifier.field;
        else if (axisItem == "hAxis") fieldname = spec.layout.column[spec.layout.column.length - 1];
        else if (axisItem == "vAxis") fieldname = spec.layout.row[spec.layout.row.length - 1];
        else if (axisItem == "columnHeader") fieldname = spec.layout.row[0];
        else if (axisItem == "rowHeader") fieldname = spec.layout.column[0];
        if (fieldname?.constructor.name === "Object") fieldname = fieldname.field;
        // property changes
        const non_property = ["role", "type", "field", "label", "grid", "domain", "title", "tick"],
          subroles = ["label", "grid", "domain", "title", "tick"];
        if (option.role === undefined) {
          Object.keys(option).forEach(propertyKey => {
            let axisItemKey = { "hAxis": "haxis", "vAxis": "vaxis", "columnHeader": "columnHeader", "rowHeader": "rowHeader" }[axisItem]
            if (!non_property.includes(propertyKey)) {
              if (axisItemKey.endsWith("axis")) {
                if (spec.layout[axisItemKey] === undefined) spec.layout[axisItemKey] = {};
                if (option[propertyKey] !== null) spec.layout[axisItemKey][propertyKey] = option[propertyKey];
                else if (spec.layout[axisItem]?.[propertyKey] !== undefined && spec.layout[axisItem]?.[propertyKey] !== null)
                  delete spec.layout[axisItem][propertyKey];
              } else {
                spec.layer.forEach(layerItem => {
                  layerItem.text.forEach(textItem => {
                    if (textItem.field === fieldname && textItem.type === "on-axis") {
                      if (option[propertyKey] !== null) textItem[propertyKey] = option[propertyKey];
                      else delete textItem[propertyKey];
                    }
                  })
                })
              }
            } else if (subroles.includes(propertyKey)) {
              if (option[propertyKey] !== null) {
                if (propertyKey == "label") {
                  Object.keys(option[propertyKey]).forEach(subPropertyKey => {
                    spec.layer.forEach(layerItem => {
                      layerItem.text?.forEach(textItem => {
                        if (textItem.type === "on-axis" && textItem.field === fieldname) {
                          if (!["type", "field", "anchor", "padding", "gap", "offset", "items", "serial"].includes(subPropertyKey)) {
                            // element-wise
                            textItem.items.forEach((textElem, ti) => {
                              if (option[propertyKey][subPropertyKey]?.constructor.name === "Array") {
                                textElem[subPropertyKey] = option[propertyKey][subPropertyKey][ti];
                              } else if (option[propertyKey][subPropertyKey] !== null) {
                                textElem[subPropertyKey] = option[propertyKey][subPropertyKey];
                              } else delete textElem[subPropertyKey];
                            })
                          } else {
                            // global-wise
                            if (option[propertyKey][subPropertyKey] !== null) {
                              textItem[subPropertyKey] = option[propertyKey][subPropertyKey];
                            } else delete textItem[propertyKey][subPropertyKey];
                          }
                        }
                      });
                    });
                  });
                } else if (propertyKey == "tick") {
                  Object.keys(option[propertyKey]).forEach(subPropertyKey => {
                    spec.layer.forEach(layerItem => {
                      layerItem.text?.forEach(textItem => {
                        if (textItem.type === "on-axis" && textItem.field === fieldname) {
                          if (!["type", "field", "anchor", "padding", "gap", "offset", "items"].includes(subPropertyKey)) {
                            if (option[propertyKey][subPropertyKey] !== null) {
                              textItem.tick[subPropertyKey] = option[propertyKey][subPropertyKey];
                            } else delete textItem.tick[propertyKey][subPropertyKey];
                          }
                        }
                      });
                    });
                  });
                } else if (propertyKey == "title") {
                  spec.layer.forEach(layerItem => {
                    layerItem.text?.forEach(textItem => {
                      if (textItem.field === fieldname) {
                        Object.keys(option[propertyKey]).forEach(subPropertyKey => {
                          let _subPropKey = { textAlign: "align", rotate: "angle", text: "value" }[subPropertyKey] || subPropertyKey;
                          if (!["type", "field", "items"].includes(subPropertyKey)) {
                            if (option[propertyKey][subPropertyKey] !== null) {
                              textItem.title[_subPropKey] = option[propertyKey][subPropertyKey];
                            } else delete textItem.title[_subPropKey];
                          }
                        });
                      }
                    });
                  });
                } else if (propertyKey == "grid") {
                  if (option[propertyKey] == true) {
                    if (spec.layout[axisItemKey] === undefined) spec.layout[axisItemKey] = {};
                    spec.layout[axisItemKey].grid = true;
                  } else if (option[propertyKey].constructor.name === "Object") {
                    Object.keys(option[propertyKey]).forEach(subPropertyKey => {
                      if (!["type", "field"].includes(subPropertyKey)) {
                        let propChain = {
                          "strokeDash": "gridDash",
                          "stroke": "gridColor",
                          "strokeOpacity": "gridOpacity",
                          "strokeWidth": "gridWidth"
                        }[subPropertyKey];
                        if (propChain) {
                          if (option[propertyKey][subPropertyKey] !== null) spec.layout[axisItemKey][propChain] = option[propertyKey][subPropertyKey];
                          else delete spec.layout[axisItemKey][propChain];
                        }
                      }
                    });
                  }
                } else if (propertyKey == "domain") {
                  if (option[propertyKey] == true) {
                    if (spec.layout[axisItemKey] === undefined) spec.layout[axisItemKey] = {};
                    spec.layout[axisItemKey].domain = true;
                  } else if (option[propertyKey].constructor.name === "Object") {
                    if (spec.layout[axisItemKey] === undefined) spec.layout[axisItemKey] = {};
                    Object.keys(option[propertyKey]).forEach(subPropertyKey => {
                      if (!["type", "field"].includes(subPropertyKey)) {
                        let propChain = {
                          "strokeDash": "domainDash",
                          "stroke": "domainColor",
                          "strokeOpacity": "domainOpacity",
                          "strokeWidth": "domainWidth"
                        }[subPropertyKey];
                        if (propChain) {
                          if (option[propertyKey][subPropertyKey] !== null) spec.layout[axisItemKey][propChain] = option[propertyKey][subPropertyKey];
                          else delete spec.layout[axisItemKey][propChain];
                        }
                      }
                    });
                  }
                }
              } else {
                if (propertyKey == "label") {
                  spec.layer.forEach(layerItem => {
                    layerItem.text?.forEach(textItem => {
                      if (textItem.type === "on-axis" && textItem.field === fieldname) {
                        textItem.delete = true;
                      }
                    });
                    if (layerItem.text) {
                      layerItem.text = layerItem.filter(textItem => textItem.delete != true)
                    }
                  });
                } else if (propertyKey == "tick") {
                  spec.layer.forEach(layerItem => {
                    layerItem.text?.forEach(textItem => {
                      if (textItem.type === "on-axis" && textItem.field === fieldname) {
                        delete textItem.tick;
                      }
                    });
                  });
                } else if (propertyKey == "title") {
                  spec.layer.forEach(layerItem => {
                    layerItem.text?.forEach(textItem => {
                      if (textItem.field === fieldname) {
                        delete textItem.title;
                      }
                    });
                  });
                } else if (propertyKey == "grid") {
                  if (spec.layout[axisItemKey] !== undefined) {
                    spec.layout[axisItemKey].grid = false;
                    let properties = ["gridDash", "gridColor", "gridOpacity", "gridWidth"]
                    properties.forEach(prop => {
                      delete spec.layout[axisItemKey][prop]
                    });
                  }
                } else if (propertyKey == "domain") {
                  if (spec.layout[axisItemKey] !== undefined) {
                    spec.layout[axisItemKey].domain = false;
                    let properties = ["domainDash", "domainColor", "domainOpacity", "domainWidth"]
                    properties.forEach(prop => {
                      delete spec.layout[axisItemKey][prop]
                    });
                  }
                }
              }
            }
          });
        } else if (option.role == "label") {
          spec.layer.forEach(layerItem => {
            layerItem.text?.forEach(textItem => {
              if (textItem.field === fieldname) {
                Object.keys(option).forEach(propertyKey => {
                  if (!["type", "field", "anchor", "padding", "gap", "offset", "items"].includes(propertyKey)) {
                    // element-wise
                    textItem.items.forEach((textElem, ti) => {
                      if (option[propertyKey].constructor.name === "Array") {
                        textElem[propertyKey] = option[propertyKey][ti];
                      } else if (option[propertyKey] !== null) {
                        textElem[propertyKey] = option[propertyKey];
                      } else delete textElem[propertyKey];
                    })
                  } else {
                    // global-wise
                    if (option[propertyKey] !== null) {
                      textItem[propertyKey] = option[propertyKey];
                    } else delete textItem[propertyKey];
                  }
                });
              }
            });
          });
        } else if (option.role == "tick") {
          spec.layer.forEach(layerItem => {
            layerItem.text?.forEach(textItem => {
              if (textItem.field === fieldname) {
                Object.keys(option).forEach(propertyKey => {
                  if (!["type", "field", "anchor", "padding", "gap", "offset"].includes(propertyKey)) {
                    if (option[propertyKey] !== null) {
                      textItem.tick[propertyKey] = option[propertyKey];
                    } else delete textItem.tick[propertyKey];
                  }
                });
              }
            });
          });
        } else if (option.role == "title") {
          spec.layer.forEach(layerItem => {
            layerItem.text?.forEach(textItem => {
              if (textItem.field === fieldname) {
                Object.keys(option).forEach(propertyKey => {
                  if (!["type", "field", "items"].includes(propertyKey)) {
                    if (option[propertyKey] !== null) {
                      textItem.title[propertyKey] = option[propertyKey];
                    } else delete textItem.title[propertyKey];
                  }
                });
              }
            });
          });
        } else if (option.role == "grid") {
          Object.keys(option).forEach(propertyKey => {
            if (!["type", "field"].includes(propertyKey)) {
              let propChain = {
                "strokeDash": "gridDash",
                "stroke": "gridColor",
                "strokeOpacity": "gridOpacity",
                "strokeWidth": "gridWidth"
              }[propertyKey];
              if (propChain) {
                if (option[propertyKey] !== null) spec.layout[axisItem][propChain] = option[propertyKey];
                else delete spec.layout[axisItem][propChain];
              }
            }
          });
        } else if (option.role == "domain") {
          Object.keys(option).forEach(propertyKey => {
            if (!["type", "field"].includes(propertyKey)) {
              let propChain = {
                "strokeDash": "domainDash",
                "stroke": "domainColor",
                "strokeOpacity": "domainOpacity",
                "strokeWidth": "domainWidth"
              }[propertyKey];
              if (propChain) {
                if (!spec.layout[axisItem]) spec.layout[axisItem] = {};
                if (option[propertyKey] !== null) spec.layout[axisItem][propChain] = option[propertyKey];
                else delete spec.layout[axisItem][propChain];
              }
            }
          });
        }
      }
    }
  });
  return spec;
}

export function queryAxisLabel(role, spec, original, specifier, action, option) {
  let axisElements = [];
  if (specifier.field !== undefined || specifier.datatype !== undefined) {
    if (["view.axis.label", "axis.label", "text.axis.label"].includes(role) || ["view.hAxis.label", "hAxis.label", "text.hAxis.label"].includes(role)) {
      let _theField = spec.layout.column[spec.layout.column.length - 1]?.field || spec.layout.column[spec.layout.column.length - 1],
        _theType = spec.layout.column[spec.layout.column.length - 1]?.type || spec.datatype[_theField].type;
      if ((specifier.field === undefined || _theField === specifier.field) && (specifier.datatype === undefined || _theType === specifier.datatype)) {
        axisElements.push("hAxis");
      }
      _theField = spec.layout.column[0]?.field || spec.layout.column[0];
      _theType = spec.layout.column[0]?.type || spec.datatype[_theField];
      if (spec.layout.column.length == 2 && (specifier.field === undefined || _theField === specifier.field) && (specifier.datatype === undefined || _theType === specifier.datatype)) {
        axisElements.push("rowHeader")
      }
    }
    if (["view.axis.label", "axis.label", "text.axis.label"].includes(role) || ["view.vAxis.label", "vAxis.label", "text.vAxis.label"].includes(role)) {
      let _theField = spec.layout.row[spec.layout.row.length - 1]?.field || spec.layout.row[spec.layout.row.length - 1],
        _theType = spec.layout.row[spec.layout.row.length - 1]?.type || spec.datatype[_theField];
      if ((specifier.field === undefined || _theField === specifier.field) && (specifier.datatype === undefined || _theType === specifier.datatype)) {
        axisElements.push("vAxis");
      }
      _theField = spec.layout.row[0]?.field || spec.layout.row[0];
      _theType = spec.layout.row[0]?.type || spec.datatype[_theField];
      if (spec.layout.row.length == 2 && (specifier.field === undefined || _theField === specifier.field) && (specifier.datatype === undefined || _theType === specifier.datatype)) {
        axisElements.push("columnHeader");
      }
    }
  } else if (["view.hAxis.label", "hAxis.label", "text.hAxis.label", "text.hAxis.label"].includes(role) && specifier.index !== undefined) {
    // selection by index (horizontal)
    // array of indices is not yet available
    if ((specifier.index == 1 || specifier.index === "first") && spec.layout.row.length == 2) axisElements.push("columnHeader");
    else if ((specifier.index == 2 || specifier.index === "last") && spec.layout.row.length == 2) axisElements.push("hAxis");
    else if ((specifier.index === "first" || specifier.index === "last" || specifier.index == 1) && spec.layout.row.length == 1) axisElements.push("hAxis");
  } else if (["view.vAxis.label", "vAxis.label", "text.vAxis.label", "text.vAxis.label"].includes(role) && specifier.index !== undefined) {
    // selection by index (vertical)
    // array of indices is not yet available
    if ((specifier.index == 1 || specifier.index === "first") && spec.layout.row.length == 2) axisElements.push("rowHeader");
    else if ((specifier.index == 2 || specifier.index === "last") && spec.layout.row.length == 2) axisElements.push("vAxis");
    else if ((specifier.index === "first" || specifier.index === "last" || specifier.index == 1) && spec.layout.row.length == 1) axisElements.push("vAxis");
  } else {
    if (["view.axis.label", "axis.label", "text.axis.label"].includes(role)) {
      axisElements = ["hAxis", "vAxis"];
      if (spec.layout.row?.length > 1) axisElements.push("rowHeader");
      if (spec.layout.column?.length > 1) axisElements.push("columnHeader");
    } else if (["view.hAxis.label", "hAxis.label", "text.hAxis.label", "text.hAxis.label"].includes(role)) {
      axisElements = ["hAxis"];
      if (spec.layout.column?.length > 1) axisElements.push("columnHeader");
    } else if (["view.vAxis.label", "vAxis.label", "text.vAxis.label", "text.vAxis.label"].includes(role)) {
      axisElements = ["vAxis"];
      if (spec.layout.row?.length > 1) axisElements.push("rowHeader");
    }
  }
  return axisElements;
}

const AxisLabelGlobalProperties = ["type", "field", "anchor", "orient", "padding", "gap", "offset", "items", "angle", "dx", "dy", "values", "serial", "offset", "flex"]

export async function AxisLabelTransformation(role, spec, original, specifier, action, option) {
  let axisElements = queryAxisLabel(role, spec, original, specifier, action, option);

  let fieldname;
  if (axisElements.length == 0) {
    if (specifier.field !== undefined) {
      axisElements.push("removed")
    }
  }

  axisElements.forEach(axisItem => {
    if (action === "add") {
      let values;
      if (option?.values !== undefined || specifier.values !== undefined) {
        if (specifier.values !== undefined && option?.values == undefined) values = specifier.values;
        // else values = option.values;
      }
      // get fieldname
      if (specifier.field) fieldname = specifier.field;
      else if (axisItem == "hAxis") fieldname = spec.layout.column[spec.layout.column.length - 1];
      else if (axisItem == "vAxis") fieldname = spec.layout.row[spec.layout.row.length - 1];
      else if (axisItem == "columnHeader") fieldname = spec.layout.row[0];
      else if (axisItem == "rowHeader") fieldname = spec.layout.column[0];
      if (fieldname.constructor.name === "Object") {
        if (fieldname.field) fieldname = fieldname.field;
        else if (fieldname.aggregate) fieldname = fieldname.aggregate;
      }

      spec.layer.forEach(layerItem => {
        layerItem.text?.forEach(textItem => {
          if (textItem.field === fieldname && textItem.type === "on-axis") {
            if (option.items !== undefined && option.items.length > 0) {
              if (textItem.items === undefined) textItem.items = [];
              option.items.forEach(item => {
                let newItem = {};
                Object.keys(item).forEach(subPropertyKey => {
                  let keymap = { "textAlign": "align", "fontColor": "color" };
                  let _propertyKey;
                  if (Object.keys(keymap).includes(subPropertyKey)) _propertyKey = keymap[subPropertyKey];
                  else _propertyKey = subPropertyKey;
                  if (item[subPropertyKey] !== null) {
                    newItem[_propertyKey] = item[subPropertyKey];
                  } else delete newItem[_propertyKey];
                });
                textItem.items.push(newItem);
              });
            }
          }
        });
      });

    } else if (action === "remove") {
      // get fieldname
      if (specifier.field) fieldname = specifier.field;
      else if (axisItem == "hAxis") fieldname = spec.layout.column[spec.layout.column.length - 1];
      else if (axisItem == "vAxis") fieldname = spec.layout.row[spec.layout.row.length - 1];
      else if (axisItem == "columnHeader") fieldname = spec.layout.row[0];
      else if (axisItem == "rowHeader") fieldname = spec.layout.column[0];
      else if (axisItem == "removed") fieldname = specifier.field;
      if (fieldname.constructor.name === "Object") fieldname = fieldname.field;
      // property changes
      spec.layer.forEach(layerItem => {
        if (layerItem.text !== undefined) {
          layerItem.text.forEach(textItem => {//inverse
            if ((fieldname === undefined || textItem.field === fieldname) && textItem.type === "on-axis") {
              if (option?.values !== undefined) { // partial
                textItem.values = textItem.values.filter(d => !option.values.includes(d));
              } else if (specifier["values.index"] !== undefined || option?.["values.index"] !== undefined) {
                let valuesIndex = (specifier["values.index"] !== undefined ? specifier["values.index"] : option["values.index"]);
                if (valuesIndex === "even") {
                  textItem.values = textItem.values.filter((d, i) => i % 2 == 0);
                } else if (valuesIndex === "odd") {
                  textItem.values = textItem.values.filter((d, i) => i % 2 == 1);
                } else if (valuesIndex.constructor.name == "Array") {
                  textItem.values = textItem.values.filter((d, i) => valuesIndex.includes(i));
                }
              } else if (option?.items?.index !== undefined) {
                let indices = option.items.index;
                if (option?.items?.index !== null && textItem.items !== undefined) {
                  if (indices.constructor.name === "Number") indices = [indices];
                  textItem.items = textItem.items.filter((d, i) => !indices.includes(i));
                }
              } else { // entire
                // textItem.items = textItem.items.map(elem => {
                //   let newElem = {
                //     "expression": "''"
                //   };
                //   if (elem.condition !== undefined) newElem.condition = elem.condition;
                //   return newElem;
                // });
                // textItem.width = 0;
                textItem.delete = true;
              }
            }
            return true;
          });
          layerItem.text = layerItem.text.filter((t) => { return !t.delete });
        }
      });
    } else if (action === "replace") {
      // get fieldname
      if (specifier.field) fieldname = specifier.field;
      else if (axisItem == "hAxis") fieldname = spec.layout.column[spec.layout.column.length - 1];
      else if (axisItem == "vAxis") fieldname = spec.layout.row[spec.layout.row.length - 1];
      else if (axisItem == "columnHeader") fieldname = spec.layout.row[0];
      else if (axisItem == "rowHeader") fieldname = spec.layout.column[0];
      else if (axisItem == "removed") fieldname = specifier.field;
      if (fieldname.constructor.name === "Object") fieldname = fieldname.field;
      // todo
      if (option?.to !== undefined) {
        // property changes
        spec.layer.forEach(layerItem => {
          layerItem.text?.forEach(textItem => {
            if (textItem.field === fieldname && textItem.type === "on-axis") {
              if (option.to.role === "mark.label") {
                textItem.type = "on-mark";
                Object.keys(option.to).forEach(propertyKey => {
                  if (!["orient", "anchor", "dx", "dy", "angle", "role", "field", "mark", "operation", "channel"].includes(propertyKey)) {
                    let keymap = { "textAlign": "align", "fontColor": "color", "anchor": "anchorAlign" };
                    let _propertyKey = keymap[propertyKey] || propertyKey;
                    textItem.items?.forEach((textElem, tei) => {
                      if (option.to[propertyKey] === null) delete textElem[_propertyKey];
                      else if (option.to[propertyKey].constructor.name === "Array" && option.to[propertyKey][tei] !== undefined) textElem[_propertyKey] = option.to[propertyKey][tei];
                      else textElem[_propertyKey] = option.to[propertyKey];
                    });
                  } else if (!["role", "field", "mark", "operation", "channel"].includes(propertyKey)) {
                    let keymap = { "textAlign": "align", "fontColor": "color", "anchor": "anchorAlign" };
                    let _propertyKey = keymap[propertyKey] || propertyKey;
                    if (propertyKey == "position") {
                      if (option.to[propertyKey] !== null) {
                        if (option.to.orient.constructor.name === "String") {
                          textItem[_propertyKey] = option.to[propertyKey];
                        }
                      } else {
                        delete textItem[_propertyKey];
                      }
                    } else {
                      if (option.to[propertyKey] !== null) textItem[_propertyKey] = option.to[propertyKey];
                      else textItem[_propertyKey];
                    }
                  }
                })
              }
            }
          });
        });
      } else if (option !== undefined) {
        // property changes
        spec.layer.forEach(layerItem => {
          layerItem.text?.forEach(textItem => {
            if (textItem.field === fieldname && textItem.type === "on-axis") {
              if (option.text?.constructor.name === "Array" && option.text.every(ta => (ta.from !== undefined && ta.to !== undefined))) {
                let map = {}
                option.text.forEach(ta => {
                  let a = (ta.from.constructor.name === "String" ? ta.from : ta.from.text);
                  let b = (ta.to.constructor.name === "String" ? ta.to : ta.to.text);
                  map[a] = b;
                });
                map = JSON.stringify(map);
                textItem.items.forEach(textElem => {
                  if (textElem.expression !== undefined) {
                    textElem.expression = "(" + map + "[" + textElem.expression + "] ? " + map + "[" + textElem.expression + "] : " + textElem.expression + "  )";
                  } else {
                    textElem.expression = "(" + map + "[datum.value] ? " + map + "[datum.value] : datum.value )";
                  }
                })
              }
            }
          });
        });
      }
    } else if (action === "modify" || action === "reposition") {
      const defaultForNull = {
        "width": 120,
        "fontSize": 12
      }
      if (option !== undefined) {
        let values;
        if (option?.values !== undefined || specifier.values !== undefined) {
          if (specifier.values !== undefined && option?.values == undefined) values = specifier.values;
          // else values = option.values;
        }
        // get fieldname
        if (specifier.field) fieldname = specifier.field;
        else if (axisItem == "hAxis") fieldname = spec.layout.column[spec.layout.column.length - 1];
        else if (axisItem == "vAxis") fieldname = spec.layout.row[spec.layout.row.length - 1];
        else if (axisItem == "columnHeader") fieldname = spec.layout.row[0];
        else if (axisItem == "rowHeader") fieldname = spec.layout.column[0];
        if (fieldname.constructor.name === "Object") fieldname = fieldname.field;
        // property changes
        spec.layer.forEach(layerItem => {
          layerItem.text?.forEach(textItem => {
            if (textItem.field === fieldname && textItem.type === "on-axis") {
              Object.keys(option).forEach(propertyKey => {
                if (!AxisLabelGlobalProperties.includes(propertyKey)) {
                  // element-wise
                  let _propertyKey;
                  if (propertyKey === "textAlign") _propertyKey = "align";
                  else _propertyKey = propertyKey;
                  if (!values) { // no specific conditions
                    textItem.items.forEach((textElem, ti) => {
                      if (option[propertyKey] === null) {
                        delete textElem[_propertyKey];
                      } else if (option[propertyKey].constructor.name === "Array") {
                        textElem[_propertyKey] = option[propertyKey][ti];
                      } else if (option[propertyKey].constructor.name === "Object" && option[propertyKey].prod !== undefined) {
                        textElem[_propertyKey] = (textElem[_propertyKey] || defaultForNull[_propertyKey]) * option[propertyKey].prod;
                      } else if (option[propertyKey].constructor.name === "Object" && option[propertyKey].by !== undefined) {
                        textElem[_propertyKey] = (textElem[_propertyKey] || defaultForNull[_propertyKey]) + option[propertyKey].by;
                      } else {
                        textElem[_propertyKey] = option[propertyKey];
                      }
                    });
                  } else {
                    let _propertyKey;
                    if (propertyKey === "textAlign") _propertyKey = "align";
                    else _propertyKey = propertyKey;
                    if (textItem.values) {
                      values = values.filter(d => textItem.values.includes(d));
                    }
                    let conditioned_items = textItem.items.filter(d => d.condition !== undefined);
                    let unconditioned_items = textItem.items.filter(d => d.condition === undefined);
                    let additional_items = [];
                    conditioned_items.forEach((textElem, ti) => {
                      if (textElem.condition.constructor.name !== "Array" && values.includes(textElem.condition)) {
                        if (option[propertyKey].constructor.name === "Array") {
                          textElem[_propertyKey] = option[propertyKey][ti];
                        } else if (option[propertyKey].constructor.name === "Object" && option[propertyKey].prod !== undefined) {
                          textElem[_propertyKey] = (textElem[_propertyKey] || defaultForNull[_propertyKey]) * option[propertyKey].prod;
                        } else if (option[propertyKey].constructor.name === "Object" && option[propertyKey].by !== undefined) {
                          textElem[_propertyKey] = (textElem[_propertyKey] || defaultForNull[_propertyKey]) + option[propertyKey].by;
                        } else if (option[propertyKey] !== null) {
                          textElem[_propertyKey] = option[propertyKey];
                        } else delete textElem[_propertyKey];
                      } else if (textElem.condition.constructor.name === "Array" && textElem.condition.every(d => values.includes(d))) {
                        if (option[propertyKey].constructor.name === "Array") {
                          textElem[_propertyKey] = option[propertyKey][ti];
                        } else if (option[propertyKey].constructor.name === "Object" && option[propertyKey].prod !== undefined) {
                          textElem[_propertyKey] = (textElem[_propertyKey] || defaultForNull[_propertyKey]) * option[propertyKey].prod;
                        } else if (option[propertyKey].constructor.name === "Object" && option[propertyKey].by !== undefined) {
                          textElem[_propertyKey] = (textElem[_propertyKey] || defaultForNull[_propertyKey]) + option[propertyKey].by;
                        } else if (option[propertyKey] !== null) {
                          textElem[_propertyKey] = option[propertyKey];
                        } else delete textElem[_propertyKey];
                      } else if (textElem.condition.constructor.name === "Array" && textElem.condition.some(d => values.includes(d))) {
                        let add_item = deepcopy(textElem);
                        add_item.condition = textElem.condition.filter(d => values.includes(d));
                        if (option[propertyKey].constructor.name === "Array") {
                          add_item[_propertyKey] = option[propertyKey][ti];
                        } else if (option[propertyKey].constructor.name === "Object" && option[propertyKey].prod !== undefined) {
                          add_item[_propertyKey] = (add_item[_propertyKey] || defaultForNull[_propertyKey]) * option[propertyKey].prod;
                        } else if (option[propertyKey].constructor.name === "Object" && option[propertyKey].by !== undefined) {
                          add_item[_propertyKey] = (add_item[_propertyKey] || defaultForNull[_propertyKey]) + option[propertyKey].by;
                        } else if (option[propertyKey] !== null) {
                          add_item[_propertyKey] = option[propertyKey];
                        } else delete add_item[_propertyKey];
                        textElem.condition = textElem.condition.filter(d => !values.includes(d));
                        additional_items.push({
                          "at": additional_items.length + ti,
                          "item": add_item
                        });
                      }
                    });
                    unconditioned_items.forEach((textElem, ti) => {
                      let add_item = deepcopy(textElem);
                      add_item.condition = textItem.values.filter(d => values.includes(d));
                      if (option[propertyKey].constructor.name === "Array") {
                        add_item[_propertyKey] = option[propertyKey][ti];
                      } else if (option[propertyKey] !== null) {
                        add_item[_propertyKey] = option[propertyKey];
                      } else delete add_item[_propertyKey];
                      textElem.condition = textItem.values.filter(d => !values.includes(d));
                      additional_items.push({
                        "at": additional_items.length + ti,
                        "item": add_item
                      });
                    });
                    if (additional_items.length > 0) additional_items.forEach((add_item_obj, ai) => {
                      textItem.items.splice(add_item_obj.at, 0, add_item_obj.item);
                    });
                  }
                } else if (propertyKey === "items") {
                  if (option.items.constructor.name === "Array") {
                    option.items.forEach((item, ii) => {
                      if (item == null) {
                        textItem.items[ii] = undefined;
                      } else {
                        Object.keys(item).forEach(subPropertyKey => {
                          let keymap = { "textAlign": "align", "fontColor": "color" };
                          let _propertyKey;
                          if (Object.keys(keymap).includes(subPropertyKey)) _propertyKey = keymap[subPropertyKey];
                          else _propertyKey = subPropertyKey;
                          if (item[subPropertyKey] !== null && textItem.items[ii]) {
                            textItem.items[ii][_propertyKey] = item[subPropertyKey];
                          } else delete textItem.items[ii]?.[_propertyKey];
                        })
                      }
                    })
                    textItem.items = textItem.items.filter(item => item !== undefined);
                  } else if (option.items.constructor.name === "Object") {
                    Object.keys(option.items).forEach(subPropertyKey => {
                      let _propertyKey;
                      if (subPropertyKey === "textAlign") _propertyKey = "align";
                      else _propertyKey = subPropertyKey;
                      textItem.items.forEach((textElem, tii) => {
                        if (option.items.index !== undefined && tii !== option.items.index) return false;
                        if (option.items[subPropertyKey] !== null) {
                          textElem[_propertyKey] = option.items[subPropertyKey];
                        } else delete textElem[_propertyKey];
                      });
                    })
                  }
                } else {
                  // global-wise
                  if (option[propertyKey] !== null) {
                    textItem[propertyKey] = option[propertyKey];
                  } else delete textItem[propertyKey];
                }
              });
            }
          });
        });
      }
    } else if (action === "transpose") {
      let values;
      if (option?.values !== undefined || specifier.values !== undefined) {
        if (specifier.values !== undefined && option?.values == undefined) values = specifier.values;
        else values = option.values;
      }
      // get fieldname
      if (specifier.field) fieldname = specifier.field;
      else if (axisItem == "hAxis") fieldname = spec.layout.column[spec.layout.column.length - 1];
      else if (axisItem == "vAxis") fieldname = spec.layout.row[spec.layout.row.length - 1];
      else if (axisItem == "columnHeader") fieldname = spec.layout.row[0];
      else if (axisItem == "rowHeader") fieldname = spec.layout.column[0];
      if (fieldname.constructor.name === "Object") fieldname = fieldname.field;
      // property changes
      spec.layer.forEach(layerItem => {
        layerItem.text?.forEach(textItem => {
          if (textItem.field === fieldname && textItem.type === "on-axis") {
            if (option.serial !== undefined) {
              if (option.serial == true) {
                textItem.serial = option.serial;
                textItem.padding = 0;
              } else delete textItem.serial
            }
          }
        });
      });
    }
  });
  if (axisElements[0] == "removed" && specifier.field !== undefined) {
    spec.layer.forEach((layer, li) => {
      layer.text?.forEach((textItem, ti) => {
        if (textItem.type === "on-axis" && textItem.field === specifier.field) {
          if (action === "replace") {
            if (option?.to !== undefined) {
              Object.keys(option.to).forEach(propertyKey => {
                if (propertyKey == "role") {
                  textItem.type = { "legend": "legend", "mark.label": "on-mark", "axis.label": "on-axis" }[option.to[propertyKey]];
                } else if (["orient", "direction", "padding", "margin"].includes(propertyKey)) {
                  let _propertyKey = propertyKey;
                  if (propertyKey === "margin") _propertyKey = "offset";
                  if (propertyKey === "padding") _propertyKey = "gap";
                  textItem[propertyKey] = option.to[propertyKey];
                }
              });
            }
          } if (action === "remove") {
            textItem.delete = true;
          }
        }
      });
      if (layer.text) {
        layer.text = layer.text?.filter(d => { return !d.delete });
      }
    })
  }
  return spec;
}

export async function AxisTickTransformation(role, spec, original, specifier, action, option) {
  let axisElements = [];
  if (specifier.field !== undefined || specifier.datatype !== undefined) {
    if (["view.axis.tick", "axis.tick"].includes(role) || ["hAxis.tick", "view.hAxis.tick"].includes(role)) {
      let _theField = spec.layout.column[spec.layout.column.length - 1]?.field || spec.layout.column[spec.layout.column.length - 1],
        _theType = spec.layout.column[spec.layout.column.length - 1]?.type || spec.datatype[_theField].type;
      if ((specifier.field === undefined || _theField === specifier.field) && (specifier.datatype === undefined || _theType === specifier.datatype)) {
        axisElements.push("hAxis");
      }
      _theField = spec.layout.column[0]?.field || spec.layout.column[0];
      _theType = spec.layout.column[0]?.type || spec.datatype[_theField].type;
      if (spec.layout.column.length == 2 && (specifier.field === undefined || _theField === specifier.field) && (specifier.datatype === undefined || _theType === specifier.datatype)) {
        axisElements.push("rowHeader")
      }
    }
    if (["view.axis.tick", "axis.tick"].includes(role) || ["hAxis.tick", "view.hAxis.tick"].includes(role)) {
      let _theField = spec.layout.row[spec.layout.row.length - 1]?.field || spec.layout.row[spec.layout.row.length - 1],
        _theType = spec.layout.row[spec.layout.row.length - 1]?.type || spec.datatype[_theField].type;
      if ((specifier.field === undefined || _theField === specifier.field) && (specifier.datatype === undefined || _theType === specifier.datatype)) {
        axisElements.push("vAxis");
      }
      _theField = spec.layout.row[0]?.field || spec.layout.row[0];
      _theType = spec.layout.row[0]?.type || spec.datatype[_theField].type;
      if (spec.layout.row.length == 2 && (specifier.field === undefined || _theField === specifier.field) && (specifier.datatype === undefined || _theType === specifier.datatype)) {
        axisElements.push("columnHeader");
      }
    }
  } else if (["view.hAxis.tick", "hAxis.tick"].includes(role) && specifier.index !== undefined) {
    // selection by index (horizontal)
    // array of indices is not yet available
    if ((specifier.index == 1 || specifier.index === "first") && spec.layout.row.length == 2) axisElements.push("columnHeader");
    else if ((specifier.index == 2 || specifier.index === "last") && spec.layout.row.length == 2) axisElements.push("hAxis");
    else if ((specifier.index === "first" || specifier.index === "last" || specifier.index == 1) && spec.layout.row.length == 1) axisElements.push("hAxis");
  } else if (["view.vAxis.tick", "vAxis.tick"].includes(role) && specifier.index !== undefined) {
    // selection by index (vertical)
    // array of indices is not yet available
    if ((specifier.index == 1 || specifier.index === "first") && spec.layout.row.length == 2) axisElements.push("rowHeader");
    else if ((specifier.index == 2 || specifier.index === "last") && spec.layout.row.length == 2) axisElements.push("vAxis");
    else if ((specifier.index === "first" || specifier.index === "last" || specifier.index == 1) && spec.layout.row.length == 1) axisElements.push("vAxis");
  } else {
    if (["view.axis.tick", "axis.tick"].includes(role)) {
      axisElements = ["hAxis", "vAxis"];
      if (spec.layout.row?.length > 1) axisElements.push("rowHeader");
      if (spec.layout.column?.length > 1) axisElements.push("columnHeader");
    } else if (["view.hAxis.tick", "hAxis.tick"].includes(role)) {
      axisElements = ["hAxis"];
      if (spec.layout.column?.length > 1) axisElements.push("columnHeader");
    } else if (["view.vAxis.tick", "vAxis.tick"].includes(role)) {
      axisElements = ["vAxis"];
      if (spec.layout.row?.length > 1) axisElements.push("rowHeader");
    }
  }
  let fieldname;
  axisElements.forEach(axisItem => {
    if (action === "add") {
      //todo
      if (axisItem == "hAxis") spec.layout.haxis.tick = true;
      else if (axisItem == "vAxis") spec.layout.vaxis.tick = true;
    } else if (action === "remove") {
      // get fieldname
      // removal
      if (specifier.field) fieldname = specifier.field;
      else if (axisItem == "hAxis") fieldname = spec.layout.column[spec.layout.column.length - 1];
      else if (axisItem == "vAxis") fieldname = spec.layout.row[spec.layout.row.length - 1];
      else if (axisItem == "columnHeader") fieldname = spec.layout.row[0];
      else if (axisItem == "rowHeader") fieldname = spec.layout.column[0];
      if (fieldname.constructor.name === "Object") fieldname = fieldname.field || fieldname.aggregate;
      if (axisItem === "hAxis" || axisItem === "vAxis") {
        // label tick setting
        spec.layer?.forEach((layer) => {
          layer.text?.forEach((textItem) => {
            if (textItem.field === fieldname) {
              delete textItem.tick;
            }
          });
        });
      }
    } else if (action === "modify" || action === "reposition") {
      if (specifier.field) fieldname = specifier.field;
      else if (axisItem == "hAxis") fieldname = spec.layout.column[spec.layout.column.length - 1];
      else if (axisItem == "vAxis") fieldname = spec.layout.row[spec.layout.row.length - 1];
      else if (axisItem == "columnHeader") fieldname = spec.layout.row[0];
      else if (axisItem == "rowHeader") fieldname = spec.layout.column[0];
      if (fieldname.constructor.name === "Object") fieldname = fieldname.field || fieldname.aggregate;
      if (axisItem === "hAxis" || axisItem === "vAxis") {
        // label tick setting
        if (option !== undefined) {
          spec.layer?.forEach((layer) => {
            layer.text?.forEach((textItem) => {
              if (textItem.field === fieldname) {
                if (textItem.tick === undefined) textItem.tick = {};
                Object.keys(option).forEach(propertyKey => {
                  let _propertyKey = { "strokeDash": "dash", "stroke": "color", "strokeWidth": "width", "strokeOpacity": "opacity" }[propertyKey] || propertyKey;
                  if (!["role", "values", "items", "dx", "dy", "angle", "orient", "anchor", "x", "y", "textAlign"].includes(propertyKey)) {
                    if (option[_propertyKey] === null) delete textItem.tick[propertyKey];
                    else textItem.tick[_propertyKey] = option[propertyKey];
                  }
                });
              }
            });
          });
        }
      }
    }
  });
  return spec;
}

export async function AxisGridTransformation(role, spec, original, specifier, action, option) {
  let axisElements = [];
  if (specifier.field !== undefined || specifier.datatype !== undefined) {
    if (["view.axis.grid", "axis.grid"].includes(role) || ["hAxis.grid", "view.hAxis.grid"].includes(role)) {
      let _theField = spec.layout.column[spec.layout.column.length - 1]?.field || spec.layout.column[spec.layout.column.length - 1],
        _theType = spec.layout.column[spec.layout.column.length - 1]?.type || spec.datatype[_theField].type;
      if ((specifier.field === undefined || _theField === specifier.field) && (specifier.datatype === undefined || _theType === specifier.datatype)) {
        axisElements.push("hAxis");
      }
      _theField = spec.layout.column[0]?.field || spec.layout.column[0];
      _theType = spec.layout.column[0]?.type || spec.datatype[_theField].type;
      if (spec.layout.column.length == 2 && (specifier.field === undefined || _theField === specifier.field) && (specifier.datatype === undefined || _theType === specifier.datatype)) {
        axisElements.push("rowHeader")
      }
    }
    if (["view.axis.grid", "axis.grid"].includes(role) || ["hAxis.grid", "view.hAxis.grid"].includes(role)) {
      let _theField = spec.layout.row[spec.layout.row.length - 1]?.field || spec.layout.row[spec.layout.row.length - 1],
        _theType = spec.layout.row[spec.layout.row.length - 1]?.type || spec.datatype[_theField].type;
      if ((specifier.field === undefined || _theField === specifier.field) && (specifier.datatype === undefined || _theType === specifier.datatype)) {
        axisElements.push("vAxis");
      }
      _theField = spec.layout.row[0]?.field || spec.layout.row[0];
      _theType = spec.layout.row[0]?.type || spec.datatype[_theField].type;
      if (spec.layout.row.length == 2 && (specifier.field === undefined || _theField === specifier.field) && (specifier.datatype === undefined || _theType === specifier.datatype)) {
        axisElements.push("columnHeader");
      }
    }
  } else if (["view.hAxis.grid", "hAxis.grid"].includes(role) && specifier.index !== undefined) {
    // selection by index (horizontal)
    // array of indices is not yet available
    if ((specifier.index == 1 || specifier.index === "first") && spec.layout.row.length == 2) axisElements.push("columnHeader");
    else if ((specifier.index == 2 || specifier.index === "last") && spec.layout.row.length == 2) axisElements.push("hAxis");
    else if ((specifier.index === "first" || specifier.index === "last" || specifier.index == 1) && spec.layout.row.length == 1) axisElements.push("hAxis");
  } else if (["view.vAxis.grid", "vAxis.grid"].includes(role) && specifier.index !== undefined) {
    // selection by index (vertical)
    // array of indices is not yet available
    if ((specifier.index == 1 || specifier.index === "first") && spec.layout.row.length == 2) axisElements.push("rowHeader");
    else if ((specifier.index == 2 || specifier.index === "last") && spec.layout.row.length == 2) axisElements.push("vAxis");
    else if ((specifier.index === "first" || specifier.index === "last" || specifier.index == 1) && spec.layout.row.length == 1) axisElements.push("vAxis");
  } else {
    if (["view.axis.grid", "axis.grid"].includes(role)) {
      axisElements = ["hAxis", "vAxis"];
      if (spec.layout.row?.length > 1) axisElements.push("rowHeader");
      if (spec.layout.column?.length > 1) axisElements.push("columnHeader");
    } else if (["view.hAxis.grid", "hAxis.grid"].includes(role)) {
      axisElements = ["hAxis"];
      if (spec.layout.column?.length > 1) axisElements.push("columnHeader");
    } else if (["view.vAxis.grid", "vAxis.grid"].includes(role)) {
      axisElements = ["vAxis"];
      if (spec.layout.row?.length > 1) axisElements.push("rowHeader");
    }
  }
  // let fieldname;
  axisElements.forEach(axisItem => {
    if (action === "add") {
      //todo
      if (axisItem == "hAxis") spec.layout.haxis.grid = true;
      else if (axisItem == "vAxis") spec.layout.vaxis.grid = true;
    } else if (action === "remove") {
      // get fieldname
      // if (specifier.field) fieldname = specifier.field;
      // else if (axisItem == "hAxis") fieldname = spec.layout.column[spec.layout.column.length - 1];
      // else if (axisItem == "vAxis") fieldname = spec.layout.row[spec.layout.row.length - 1];
      // else if (axisItem == "columnHeader") fieldname = spec.layout.row[0];
      // else if (axisItem == "rowHeader") fieldname = spec.layout.column[0];
      // if (fieldname.constructor.name === "Object") fieldname = fieldname.field;
      // removal
      if (axisItem == "hAxis") spec.layout.haxis.grid = false;
      else if (axisItem == "vAxis") spec.layout.vaxis.grid = false;
    } else if (action === "modify" || action === "reposition") {
      // todo
    }
  });
  return spec;
}